import { cn } from './cn';

type Item<K extends string> = { key: K; label: string; count?: number; title?: string };

/**
 * Ряд кнопок в одной рамке: вкладки панели, пресеты диапазона, разделы справки. role задаёт
 * семантику: 'tabs' — tablist/aria-selected, 'group' — group/aria-pressed (пресеты, панель).
 * value null — ничего не выбрано (панель закрыта).
 */
export function SegmentedControl<K extends string>({ items, value, onChange, role, label, className }: {
  items: Item<K>[]; value: K | null; onChange: (k: K) => void; role: 'tabs' | 'group'; label: string; className?: string;
}) {
  return (
    <span role={role === 'tabs' ? 'tablist' : 'group'} aria-label={label} className={cn('inline-flex h-8 rounded-md border border-gray-300 overflow-hidden', className)}>
      {items.map((it) => {
        const active = value === it.key;
        return (
          <button
            key={it.key} type="button" title={it.title}
            {...(role === 'tabs' ? { role: 'tab', 'aria-selected': active } : { 'aria-pressed': active })}
            className={cn('min-h-0 h-full px-3 text-sm font-semibold border-r border-gray-300 last:border-r-0', active ? 'bg-gray-200' : 'bg-white hover:bg-gray-100')}
            onClick={() => onChange(it.key)}
          >
            {it.label}{it.count !== undefined && <span className="text-gray-500 font-normal"> {it.count}</span>}
          </button>
        );
      })}
    </span>
  );
}
